import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import { Flex, LINK_VARIANT_HIGHLIGHT, Link } from 'mailup-web-components'

import { panelConfigColumnsRestoreCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'

const Restore: FC = () => {
  const intl = useIntl()

  const handleClick = useRecoilCallback(panelConfigColumnsRestoreCallback, [])

  return (
    <Flex justifyContent="flex-end">
      <Link
        variant={LINK_VARIANT_HIGHLIGHT}
        data-mu-test="restore-columns"
        onClick={handleClick}
      >
        {intl.formatMessage({ id: 'Load.RecipientsList.ActionRestoreColumns' })}
      </Link>
    </Flex>
  )
}

export default Restore
